import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../utils/commonInstance"; 
import { showToast } from "../../hooks/showToast";

// async thunk to fetch role rights once (on login)
export const fetchRoleRights = createAsyncThunk("roleRights/fetchRoleRights", async ({ roleId }, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`web/getrolerightsdata/${roleId}`);
    return response?.data?.data || [];
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message || "Failed to fetch role rights");
  }
});

const roleRightsSlice = createSlice({
  name: "roleRights",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearRoleRights(state) {
      state.data = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoleRights.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRoleRights.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchRoleRights.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        showToast(action.payload, "error");
      });
  },
});

export const { clearRoleRights } = roleRightsSlice.actions;
export const selectRoleRights = (state) => state.roleRights.data;
export const selectRoleRightsLoading = (state) => state.roleRights.loading;

export default roleRightsSlice.reducer;
